export const columns = [
	{
		dataField: 'NumeroSesion',
		text: 'Número Sesión',
	},
	{
		dataField: 'Fecha',
		text: 'Fecha',
	},
	{
		dataField: 'Hora',
		text: 'Hora',
	},
	{
		dataField: 'FundamentoJuridico',
		text: 'Fundamento Juridico',
	},
	{
		dataField: 'NombreCorto',
		text: 'Nombre Corto',
	},
];

export const columsHeader = [
	{
		dataField: 'Mensaje',
		text: 'Error en Columnas',
	},
];

export const items = [
	{
		id: 1,
		NumeroSesion: 'El numero de sesion debe ser numerico',
		Fecha: 'Formato incorrecto',
		Hora: 'Formato incorrecto',
		FundamentoJuridico: 'El fundamento juridico no puede ser null o vacio',
		NombreCorto: 'El nombre no puede ser null o vacio',
	},
	{
		id: 2,
		NumeroSesion: 'El numero de sesion no puede ser null o vacio',
		Fecha: 'Formato incorrecto',
		Hora: 'Formato incorrecto',
		FundamentoJuridico: 'El fundamento juridico no puede ser null',
		NombreCorto: 'El nombre no puede ser null',
	},
	{
		id: 3,
		NumeroSesion: 'CORRECTO',
		Fecha: 'CORRECTO',
		Hora: 'CORRECTO',
		FundamentoJuridico: 'CORRECTO',
		NombreCorto: 'CORRECTO',
	},
	{
		id: 4,
		NumeroSesion: 'CORRECTO',
		Fecha: 'CORRECTO',
		Hora: 'CORRECTO',
		FundamentoJuridico: 'CORRECTO',
		NombreCorto: 'CORRECTO',
	},
];

export const itemsCorrectos = [
	{
		id: 1,
		NumeroSesion: 'CORRECTO',
		Fecha: 'CORRECTO',
		Hora: 'CORRECTO',
		FundamentoJuridico: 'CORRECTO',
		NombreCorto: 'CORRECTO',
	},
	{
		id: 2,
		NumeroSesion: 'CORRECTO',
		Fecha: 'CORRECTO',
		Hora: 'CORRECTO',
		FundamentoJuridico: 'CORRECTO',
		NombreCorto: 'CORRECTO',
	},
	{
		id: 3,
		NumeroSesion: 'CORRECTO',
		Fecha: 'CORRECTO',
		Hora: 'CORRECTO',
		FundamentoJuridico: 'CORRECTO',
		NombreCorto: 'CORRECTO',
	},
	{
		id: 4,
		NumeroSesion: 'CORRECTO',
		Fecha: 'CORRECTO',
		Hora: 'CORRECTO',
		FundamentoJuridico: 'CORRECTO',
		NombreCorto: 'CORRECTO',
	},
];

export const userTypeTabs = [
	{
		label: 'Asamblea General',
		filas: [
			{
				id: 1,
				NumeroSesion: 'CORRECTO1',
				Fecha: 'CORRECTO1',
				Hora: 'CORRECTO1',
				FundamentoJuridico: 'CORRECTO1',
				NombreCorto: 'CORRECTO1',
			},
		],
	},
	{
		label: 'Comisión De Vigilancia',
		filas: [
			{
				id: 2,
				NumeroSesion: 'CORRECTO2',
				Fecha: 'CORRECTO2',
				Hora: 'CORRECTO2',
				FundamentoJuridico: 'CORRECTO2',
				NombreCorto: 'CORRECTO2',
			},
		],
	},
	{
		label: 'Comisión de Inconformidades',
		filas: [
			{
				id: 1,
				NumeroSesion: 'El numero de sesion debe ser numerico',
				Fecha: 'Formato incorrecto',
				Hora: 'Formato incorrecto',
				FundamentoJuridico: 'El fundamento juridico no puede ser null o vacio',
				NombreCorto: 'El nombre no puede ser null o vacio',
			},
			{
				id: 2,
				NumeroSesion: 'El numero de sesion no puede ser null o vacio',
				Fecha: 'Formato incorrecto',
				Hora: 'Formato incorrecto',
				FundamentoJuridico: 'El fundamento juridico no puede ser null',
				NombreCorto: 'El nombre no puede ser null',
			},
		],
	},
];
export const userTypeTabs2 = {
	'Asamblea General': [
		{
			fila: 0,
			contenido: [
				{
					columna: 0,
					campo: 'numeroSesion',
					validacion: false,
					mensaje: "La columna 'numeroSesion' no es valida.",
				},
				{
					columna: 1,
					campo: 'fecha',
					validacion: false,
					mensaje: "La columna 'fecha' no es valida.",
				},
				{
					columna: 2,
					campo: 'hora',
					validacion: false,
					mensaje: "La columna 'hora' no es valida.",
				},
				{
					columna: 3,
					campo: 'fundamentoJuridico',
					validacion: false,
					mensaje: "La columna 'fundamentoJuridico' no es valida.",
				},
				{
					columna: 4,
					campo: 'nombreCorto',
					validacion: false,
					mensaje: "La columna 'nombreCorto' no es valida.",
				},
			],
		},
		{
			fila: 1,
			contenido: [
				{
					columna: 0,
					campo: 'NUMERO_SESION',
					validacion: false,
					mensaje:
						"La columna 'NUMERO_SESION' tiene un formato distinto de texto.",
				},
				{
					columna: 1,
					campo: 'FECHA',
					valor: '11-01-2022',
					validacion: true,
				},
				{
					columna: 2,
					campo: 'HORA',
					valor: '11:00',
					validacion: true,
				},
				{
					columna: 3,
					campo: 'FUNDAMENTO_JURIDICO',
					valor: 'Con fundamento en lo dispuesto en el artÃ­culo 18 Bis de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, y en los tÃ©rminos del Libro II, TÃ­tulo Ãšnico, CapÃ­tulo I, CapÃ­tulo II y CapÃ­tulo IV de las â€œReglas de OperaciÃ³n de los Ã“rganos Colegiados del Instituto del Fondo Nacional de la Vivienda para los Trabajadoresâ€, aprobadas por la Asamblea General del Infonavit',
					validacion: true,
				},
				{
					columna: 4,
					campo: 'NOMBRE_CORTO',
					valor: '199, 13 ene 22',
					validacion: true,
				},
			],
		},
		{
			fila: 2,
			contenido: [
				{
					columna: 0,
					campo: 'NUMERO_SESION',
					validacion: false,
					mensaje:
						"La columna 'NUMERO_SESION' tiene un formato distinto de texto.",
				},
				{
					columna: 1,
					campo: 'FECHA',
					valor: '11-01-2022',
					validacion: true,
				},
				{
					columna: 2,
					campo: 'HORA',
					valor: '11:01',
					validacion: true,
				},
				{
					columna: 3,
					campo: 'FUNDAMENTO_JURIDICO',
					valor: 'Con fundamento en lo dispuesto en el artÃ­culo 18 Bis de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, y en los tÃ©rminos del Libro II, TÃ­tulo Ãšnico, CapÃ­tulo I, CapÃ­tulo II y CapÃ­tulo IV de las â€œReglas de OperaciÃ³n de los Ã“rganos Colegiados del Instituto del Fondo Nacional de la Vivienda para los Trabajadoresâ€, aprobadas por la Asamblea General del Infonavit',
					validacion: true,
				},
				{
					columna: 4,
					campo: 'NOMBRE_CORTO',
					valor: '200, 14 ene 23',
					validacion: true,
				},
			],
		},
		{
			fila: 3,
			contenido: [
				{
					columna: 0,
					campo: 'NUMERO_SESION',
					validacion: false,
					mensaje:
						"La columna 'NUMERO_SESION' tiene un formato distinto de texto.",
				},
				{
					columna: 1,
					campo: 'FECHA',
					valor: '11-01-2022',
					validacion: true,
				},
				{
					columna: 2,
					campo: 'HORA',
					valor: '11:02',
					validacion: true,
				},
				{
					columna: 3,
					campo: 'FUNDAMENTO_JURIDICO',
					valor: 'Con fundamento en lo dispuesto en el artÃ­culo 18 Bis de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, y en los tÃ©rminos del Libro II, TÃ­tulo Ãšnico, CapÃ­tulo I, CapÃ­tulo II y CapÃ­tulo IV de las â€œReglas de OperaciÃ³n de los Ã“rganos Colegiados del Instituto del Fondo Nacional de la Vivienda para los Trabajadoresâ€, aprobadas por la Asamblea General del Infonavit',
					validacion: true,
				},
				{
					columna: 4,
					campo: 'NOMBRE_CORTO',
					valor: '201, 15 ene 24',
					validacion: true,
				},
			],
		},
		{
			fila: 4,
			contenido: [
				{
					columna: 0,
					campo: 'NUMERO_SESION',
					validacion: false,
					mensaje:
						"La columna 'NUMERO_SESION' tiene un formato distinto de texto.",
				},
				{
					columna: 1,
					campo: 'FECHA',
					valor: '11-01-2022',
					validacion: true,
				},
				{
					columna: 2,
					campo: 'HORA',
					valor: '11:03',
					validacion: true,
				},
				{
					columna: 3,
					campo: 'FUNDAMENTO_JURIDICO',
					valor: 'Con fundamento en lo dispuesto en el artÃ­culo 18 Bis de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, y en los tÃ©rminos del Libro II, TÃ­tulo Ãšnico, CapÃ­tulo I, CapÃ­tulo II y CapÃ­tulo IV de las â€œReglas de OperaciÃ³n de los Ã“rganos Colegiados del Instituto del Fondo Nacional de la Vivienda para los Trabajadoresâ€, aprobadas por la Asamblea General del Infonavit',
					validacion: true,
				},
				{
					columna: 4,
					campo: 'NOMBRE_CORTO',
					valor: '202, 16 ene 25',
					validacion: true,
				},
			],
		},
	],
	'Comisión De Vigilancia': [
		{
			fila: 0,
			contenido: [
				{
					columna: 0,
					campo: 'numeroSesion',
					validacion: false,
					mensaje: "La columna 'numeroSesion' no es valida.",
				},
				{
					columna: 1,
					campo: 'fecha',
					validacion: false,
					mensaje: "La columna 'fecha' no es valida.",
				},
				{
					columna: 2,
					campo: 'hora',
					validacion: false,
					mensaje: "La columna 'hora' no es valida.",
				},
				{
					columna: 3,
					campo: 'fundamentoJuridico',
					validacion: false,
					mensaje: "La columna 'fundamentoJuridico' no es valida.",
				},
				{
					columna: 4,
					campo: 'nombreCorto',
					validacion: false,
					mensaje: "La columna 'nombreCorto' no es valida.",
				},
			],
		},
		{
			fila: 1,
			contenido: [
				{
					columna: 0,
					campo: 'NUMERO_SESION',
					validacion: false,
					mensaje:
						"La columna 'NUMERO_SESION' tiene un formato distinto de texto.",
				},
				{
					columna: 1,
					campo: 'FECHA',
					valor: '11-01-2022',
					validacion: true,
				},
				{
					columna: 2,
					campo: 'HORA',
					valor: '11:00',
					validacion: true,
				},
				{
					columna: 3,
					campo: 'FUNDAMENTO_JURIDICO',
					valor: 'Con fundamento en lo dispuesto en el artÃ­culo 18 Bis de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, y en los tÃ©rminos del Libro II, TÃ­tulo Ãšnico, CapÃ­tulo I, CapÃ­tulo II y CapÃ­tulo IV de las â€œReglas de OperaciÃ³n de los Ã“rganos Colegiados del Instituto del Fondo Nacional de la Vivienda para los Trabajadoresâ€, aprobadas por la Asamblea General del Infonavit',
					validacion: true,
				},
				{
					columna: 4,
					campo: 'NOMBRE_CORTO',
					valor: '199, 13 ene 22',
					validacion: true,
				},
			],
		},
		{
			fila: 2,
			contenido: [
				{
					columna: 0,
					campo: 'NUMERO_SESION',
					validacion: false,
					mensaje:
						"La columna 'NUMERO_SESION' tiene un formato distinto de texto.",
				},
				{
					columna: 1,
					campo: 'FECHA',
					valor: '11-01-2022',
					validacion: true,
				},
				{
					columna: 2,
					campo: 'HORA',
					valor: '11:00',
					validacion: true,
				},
				{
					columna: 3,
					campo: 'FUNDAMENTO_JURIDICO',
					valor: 'Con fundamento en lo dispuesto en el artÃ­culo 18 Bis de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, y en los tÃ©rminos del Libro II, TÃ­tulo Ãšnico, CapÃ­tulo I, CapÃ­tulo II y CapÃ­tulo IV de las â€œReglas de OperaciÃ³n de los Ã“rganos Colegiados del Instituto del Fondo Nacional de la Vivienda para los Trabajadoresâ€, aprobadas por la Asamblea General del Infonavit',
					validacion: true,
				},
				{
					columna: 4,
					campo: 'NOMBRE_CORTO',
					valor: '200, 14 ene 23',
					validacion: true,
				},
			],
		},
		{
			fila: 3,
			contenido: [
				{
					columna: 0,
					campo: 'NUMERO_SESION',
					validacion: false,
					mensaje:
						"La columna 'NUMERO_SESION' tiene un formato distinto de texto.",
				},
				{
					columna: 1,
					campo: 'FECHA',
					valor: '11-01-2022',
					validacion: true,
				},
				{
					columna: 2,
					campo: 'HORA',
					valor: '11:00',
					validacion: true,
				},
				{
					columna: 3,
					campo: 'FUNDAMENTO_JURIDICO',
					valor: 'Con fundamento en lo dispuesto en el artÃ­culo 18 Bis de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, y en los tÃ©rminos del Libro II, TÃ­tulo Ãšnico, CapÃ­tulo I, CapÃ­tulo II y CapÃ­tulo IV de las â€œReglas de OperaciÃ³n de los Ã“rganos Colegiados del Instituto del Fondo Nacional de la Vivienda para los Trabajadoresâ€, aprobadas por la Asamblea General del Infonavit',
					validacion: true,
				},
				{
					columna: 4,
					campo: 'NOMBRE_CORTO',
					valor: '201, 15 ene 24',
					validacion: true,
				},
			],
		},
		{
			fila: 4,
			contenido: [
				{
					columna: 0,
					campo: 'NUMERO_SESION',
					validacion: false,
					mensaje:
						"La columna 'NUMERO_SESION' tiene un formato distinto de texto.",
				},
				{
					columna: 1,
					campo: 'FECHA',
					valor: '11-01-2022',
					validacion: true,
				},
				{
					columna: 2,
					campo: 'HORA',
					valor: '11:00',
					validacion: true,
				},
				{
					columna: 3,
					campo: 'FUNDAMENTO_JURIDICO',
					valor: 'Con fundamento en lo dispuesto en el artÃ­culo 18 Bis de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, y en los tÃ©rminos del Libro II, TÃ­tulo Ãšnico, CapÃ­tulo I, CapÃ­tulo II y CapÃ­tulo IV de las â€œReglas de OperaciÃ³n de los Ã“rganos Colegiados del Instituto del Fondo Nacional de la Vivienda para los Trabajadoresâ€, aprobadas por la Asamblea General del Infonavit',
					validacion: true,
				},
				{
					columna: 4,
					campo: 'NOMBRE_CORTO',
					valor: '202, 16 ene 25',
					validacion: true,
				},
			],
		},
	],
};

export const dataForRowDefault = [
	{
		id: '',
		NumeroSesion: '',
		Fecha: '',
		Hora: '',
		FundamentoJuridico: '',
		NombreCorto: '',
		Mensaje: '',
	},
];
